/**
 * Created by gaowy on 2017/6/12.
 */

;
(function($) {
    'use strict'
    //模版文件
    //htmltemplate.js
    var ModuleName = 'ntb_lnsd';
    var Module = function(ele, options) {
        this.elem = $(ele);
        this.opts = options;
    };
    Module.DEFAULT = {
      sideHideDistance:'-275px',
      moduleHeight:'100%',
      time: 300,
      initRun: function() {
        $('.ntb_lnsd').ntb_lnsd("isAllowOpen", true);
      },
      //比較分組面板點擊回調函數
      pannelCB: function() {},
      //判斷歷史事件模式為何（預設列表模式：item）
      historyCardTemplateMode: 'item', // {String: card（卡片模式） || item(列表模式)}
      //按鈕事件
      clickItemEvents: {
        favorite: function() {
          console.log(1)
        },
        comparison: function() {
          console.log(2)
        },
        downloadPDF: function() {
          console.log(3)
        },
        previewPrint: function() {
          console.log(4)
        },
        history: function() {
          console.log(5)
        },
        share: function() {
          console.log(6)
        },
        goTop: function() {
          console.log(7)
        },
        //20170628
        shareTo: function() {} //轉寄給
      },
      //組件初始化時，賦值所有類別，要與資料中的type屬性相同
      types: {
        productforeignGIF: '團體',
        planeticketf: '機票',
        hotelforeignBookingf: '訂房',
        productforeignFITf: '雄獅自由行',
        productdemosticFIT: '台灣自由行',
        productairlineFITf: '航空自由行',
        free: '自由行',
        destination: '目的地'
      },
      banner: {
        url: '#banner',
        src: 'http://fakeimg.pl/250x100/'
      },
      isAllowOpen: false,
      favorite: null, //收藏阵列
      compare: null, //比較阵列
      history: null, //看過阵列,
      goTopText:'TOP',
      arrowIcon:'toolnext',
      menus: [
        // {aName:"favorite",iName:"toollike",describe:'收藏'},
        // {aName:"compare",iName:"toolcompare",describe:'比較'},
        // {aName:"pdfDownload",iName:"orderdownload",describe:'PDF下載'},
        // {aName:"printf",iName:"orderprintf",describe:'列印'},
        // {aName:"history",iName:"toolseenf",describe:'看過'},
        // {aName:"shares",iName:"toolsharef",describe:'分享'}
      ],
      template: {
        //右側功能列模版
        ntbLnsdTemplate:
          '<div class="side-nav">\
                    <div class="nav-header">\
                        <div class="nav-btn arrow d-no">\
                            <a class="btn-a" href="javascript:void(0)">\
                                <i class="ic-ln {%=o.arrowIcon%}"></i>\
                            </a>\
                        </div>\
                    </div>\
                    <div class="nav-main" >\
                    {% for(var i=0;i<o.menus.length;i++){ %}\
                    {% var menu=o.menus[i]; %}\
                        <div class="nav-btn">\
                            <a class="btn-a {%=menu.aName%} " href="javascript:void(0)">\
                                <i class="ic-ln {%=menu.iName%}"></i>\
                                <span class="describe">{%=menu.describe%}</span>\
                            </a>\
                        </div>\
                     {%  } %}\
                    </div>\
                    <div class="nav-footer">\
                        <div class="nav-btn">\
                            <a class="btn-a toTop" href="javascript:void(0)">\
                                <i class="ic-ln tooltop"></i>\
                                <span  class="describe" style="display:inline-block;">{%=o.goTopText%}</span>\
                            </a>\
                        </div>\
                    </div>\
                </div>\
                <div class="side-main">\
                </div>',
        //cd_gpsm模組模版
        cdGpsm:
          '\
                {% for(var i=0;i<o.data.length;i++){ %}\
                    {% var type=o.data[i].type;var section=o.data[i].section;var mainkey=o.data[i].key;var tag=o.data[i].tag;var href=o.data[i].href; %}\
                    {% var title=o.data[i].title;var content=o.data[i].content;var attrs=o.data[i].attrs;var price=o.data[i].price; %}\
                    {% var str=""; if(attrs) {for(var key in attrs){ str+=key+\'=\'+attrs[key]+\' \';} } %}\
                    <div class="cd_gpsm" section="{%=section%}" type="{%=type%}" key="{%=mainkey%}">\
                    {% if(tag === "a") { %}\
                        <{%=tag%} href="{%=href%}" target="_blank" class="{%=title.className%}" {%=str%}>\
                    {% } else { %} \
                        <{%=tag%} class="{%=title.className%}">\
                    {% } %}\
                            <h5 class="title">{%=title.value%}</h5>\
                            <div class="{%=content.className%}">\
                            {% for(var j=0;j<content.value.length;j++){ %}\
                                <p>{%=content.value[j]%}</p>\
                            {% } %}\
                            </div>\
                            {% for(var x=0;x<price.value.length;x++){ %}\
                            <p class="price">\
                                <span class="{%=price.className%}">{%=price.value[x]%} </span>\
                            </p>\
                            {% } %}\
                        </{%=tag%}>\
                        <a class="delete"></a>\
                    </div>\
                {% } %}\
            ',
        //比較模塊面板
        pannelLionBobby:
          '\
            <div class="side-main-contain compare">\
                <div class="contain-list">\
                    {% for(var i=0;i<o.items.length;i++){ %}\
                       {% if(o.items[i].data.length > 0) { %}\
                            <div class="pannel  {%=o.items[i].type%}">\
                                <a class="pannel-btn" type="{%=o.items[i].type%}" href="compare.html">\
                                    <i class="ic-ln x3 {%=o.items[i].type%}"></i>\
                                    <span class="describe">\
                                     {%=o.items[i].typeName%}比較({%=o.items[i].data.length%})\
                                     </span>\
                                </a>\
                            </div>\
                    {% }} %}\
                </div>\
            </div>\
            {% if( typeof o.banner === "object" && o.banner !== null ) { %}\
                <div class="banner-img" >\
                    <a href="{%=o.banner.url%}"><img src="{%=o.banner.src%}" /></a>\
                </div>\
            {% } %}\
            ',
        //比較模塊面板
        pannel:
          '\
                <div class="side-main-contain compare">\
                    <div class="contain-list">\
                        {% for(var i=0;i<o.items.length;i++){ %}\
                           {% if(o.items[i].data.length > 0) { %}\
                                <div class="pannel  {%=o.items[i].type%}">\
                                    <a class="pannel-btn" type="{%=o.items[i].type%}" href="compare.html">\
                                        <i class="ic-ln x3 {%=o.items[i].type%}"></i>\
                                        <span class="describe">\
                                         {%=o.items[i].typeName%}比較({%=o.items[i].data.length%}/{%=o.items[i].data.length%})\
                                         </span>\
                                    </a>\
                                </div>\
                        {% }} %}\
                    </div>\
                </div>\
                {% if( typeof o.banner === "object" && o.banner !== null ) { %}\
                    <div class="banner-img" >\
                        <a href="{%=o.banner.url%}"><img src="{%=o.banner.src%}" /></a>\
                    </div>\
                {% } %}\
                ',
        //比較模版
        comparisonTemplate:
          '\
                    <div class="side-main-contain compare">\
                        <div class="contain-list compare">\
                        </div>\
                        <div class="contain-footer compare">\
                            <a class="footer-btn" target="_blank" href="compare.html">開始比較</a>\
                        </div>\
                    </div>\
                    {% if( typeof o.banner === "object" && o.banner !== null ) { %}\
                    <div class="banner-img" >\
                        <a href="{%=o.banner.url%}"><img src="{%=o.banner.src%}" /></a>\
                    </div>\
                    {% } %}\
                ',
        //收藏模版
        favoriteTemplate:
          '\
                    <div class="side-main-contain favorite">\
                        <div class="contain-list favorite">\
                        </div>\
                        <div class="contain-footer favorite">\
                            <ul class="favorite-tips">\
                            </ul>\
                            <div class="favorite-show">\
                                <a class="footer-btn" target="_blank" href="favorite.html">查看所有收藏</a>\
                            </div>\
                        </div>\
                    </div>\
                    {% if( typeof o.banner === "object" && o.banner !== null ) { %}\
                    <div class="banner-img" >\
                        <a href="{%=o.banner.url%}"><img src="{%=o.banner.src%}" /></a>\
                    </div>\
                    {% } %}\
                ',
        //收藏模块下的统计
        lis:
          '\
                    {% for(var i=0;i<o.items.length;i++){ %}\
                        {% if(o.items[i].data.length > 0) { %}\
                        <li><a href="favorite.html" target="_blank">{%=o.items[i].typeName%}({%=o.items[i].data.length%})</a></li>\
                    {% }} %}\
                ',

        //歷史模塊面板
        historyPanel:
          '\
                <div class="side-main-contain history">\
                    <div class="contain-list history">\
                        {% for(var i=0;i<o.items.length;i++){ %}\
                           {% if(o.items[i].data.length > 0) { %}\
                                <div class="historyPanel">\
                                    <a class="historyPanel-btn" type="{%=o.items[i].type%}" href="history.html">\
                                        <i class="ic-ln x3 {%=o.items[i].type%}"></i>\
                                        <span class="describe">\
                                         {%=o.items[i].typeName%}\
                                         </span>\
                                    </a>\
                                </div>\
                        {% }} %}\
                    </div>\
                </div>\
                {% if( typeof o.banner === "object" && o.banner !== null ) { %}\
                    <div class="banner-img" >\
                        <a href="{%=o.banner.url%}"><img src="{%=o.banner.src%}" /></a>\
                    </div>\
                {% } %}\
                ',
        //歷史模版
        historyTemplate:
          '\
                    <div class="side-main-contain history">\
                        <div class="contain-list history">\
                        </div>\
                        <div class="contain-footer history">\
                            <a class="footer-btn" href="histroy.html" target="_blank">查看瀏覽紀綠</a>\
                        </div>\
                    </div>\
                    {% if( typeof o.banner === "object" && o.banner !== null ) { %}\
                    <div class="banner-img" >\
                        <a href="{%=o.banner.url%}" target="_blank"><img src="{%=o.banner.src%}" /></a>\
                    </div>\
                    {% } %}\
                ',
        //無數據模版
        nodata:
          '\
                  <div class="side-main-contain nodata">\
                    <div class="no-data">\
                      <div class="tips">\
                        <i class="ic-ln x5 toolsurveyf"></i> \
                        <h3>{%=o.content%}</h3>\
                      </div>\
                    </div>\
                   </div>\
                  {% if( typeof o.banner === "object" && o.banner !== null ) { %}\
                    <div class="banner-img" >\
                        <a href="{%=o.banner.url%}"><img src="{%=o.banner.src%}" /></a>\
                    </div>\
                    {% } %}\
                ',
        //分享模塊
        shares:
          '\
            <div class="side-main-contain shares">\
                <div class="contain-list shares">\
                    <div class="share">\
                        <a class="share-fb d-b ">\
                            <i class="i-icon d-ib"></i>\
                            <span class="d-ib" >FB分享</span>\
                        </a>\
                    </div>\
                    <div class="share" >\
                        <a class="share-fbm d-b">\
                            <i class="i-icon d-ib"></i>\
                            <span class="d-ib">FB Messenger分享</span>\
                        </a>\
                    </div>\
                    <div class="share" >\
                        <a class="share-line d-b fz-0">\
                            <i class="i-icon d-ib"></i>\
                            <span class="d-ib" >LINE分享</span>\
                        </a>\
                    </div>\
                    <div class="share" >\
                        <a class="share-g d-b fz-0">\
                            <i class="i-icon d-ib"></i>\
                            <span class="d-ib" >G+分享</span>\
                        </a>\
                    </div>\
                    <div class="share">\
                        <a class="share-o d-b fz-0 pos-rlt">\
                            <i class="i-icon d-ib"></i>\
                            <span class="d-ib" >推薦好友</span>\
                            <div class="arrow pos-abt"></div>\
                        </a>\
                        <div class="share-form fcl_lnls">\
                            <div class="fm-grp">\
                                <div class="int-grp">\
                                    <label for="e-title" class="label inside sm">主旨</label>\
                                    <input type="text" class="fm-ctrl sm" id="e-title" placeholder="請輸入電子郵件主旨">\
                                </div>\
                            </div>\
                            <div class="fm-grp">\
                                <div class="int-grp">\
                                    <label for="email" class="label inside sm">您的E-mail</label>\
                                    <input type="text" class="fm-ctrl sm" id="email" placeholder="例:abc@xxx.com">\
                                </div>\
                            </div>\
                            <div class="fm-grp">\
                                <div class="int-grp">\
                                    <label for="oemail" class="label inside sm">朋友的E-mail</label>\
                                    <input type="text" class="fm-ctrl sm" id="oemail" placeholder="例:abc@xxx.com">\
                                </div>\
                            </div>\
                            <div class="e-tips"> 多個e-mail,請用英文半形分號;分隔</div>\
                            <div>\
                                <p>請輸入下圖中的驗證碼：</p>\
                                <div class="v-code">\
                                    <img class="codeImg" src="./imgs/V-code.png"/>\
                                    <input  class="codeValue" type="text"/>\
                                    <a class="changeCode" href="javascript:void(0);">換一張</a>\
                                </div>\
                                <div class="btns clearfix">\
                                    <input class="cancel fz-md" type="button" value="取消"/>\
                                    <input class="confirm fz-md" type="button" value="送出"/>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
                </div>\
                {% if( typeof o.banner === "object" && o.banner !== null ) { %}\
                <div class="banner-img" >\
                    <a href="{%=o.banner.url%}"><img src="{%=o.banner.src%}" /></a>\
                </div>\
                {% } %}\
        ',
        //分享模塊
        shares_forward:
          '\
                <div class="side-main-contain shares">\
                    <div class="contain-list shares">\
                        <div class="share">\
                            <a class="share-f d-b fz-0 pos-rlt">\
                                <i class="i-icon d-ib"></i>\
                                <span class="d-ib">推薦好友</span>\
                            </a>\
                            <div class="share-form fcl_lnls d-b">\
                                <h4>選擇行程資料</h4>\
                                <div class="fm-grp">\
                                    <div class="int-grp">\
                                        <label for="e-title" class="label inside sm c-dk">主旨</label>\
                                        <input type="text" class="fm-ctrl sm p-l-xxl" id="e-title" placeholder="【主題旅遊】法國深度藝文">\
                                    </div>\
                                </div>\
                                <div class="fm-grp">\
                                    <div class="int-grp">\
                                        <label for="email" class="label inside sm w-40p">寄件人姓名</label>\
                                        <input type="text" class="fm-ctrl sm" id="email" placeholder="例:abc@xxx.com">\
                                    </div>\
                                </div>\
                                <div class="fm-grp">\
                                    <div class="int-grp">\
                                        <label for="oemail" class="label inside sm">寄件人E-mail</label>\
                                        <input type="text" class="fm-ctrl sm" id="oemail" placeholder="例:abc@xxx.com">\
                                    </div>\
                                </div>\
                                <div class="fm-grp">\
                                    <div class="int-grp">\
                                        <label for="oemail" class="label inside sm">收件人E-mail</label>\
                                        <input type="text" class="fm-ctrl sm" id="oemail" placeholder="例:abc@xxx.com">\
                                    </div>\
                                </div>\
                                <h4 class="d-no md-d-b">選擇行程資料</h4>\
                                <h4 class="title_change md-d-no d-b">勾選項目</h4>\
                                <div class="p-t-sm"> 已含<span class="key_name">「 行程基本資料」</span>，可再加選</div>\
                                <div class="p-b-sm">以下項目:</div>\
                                <div class="fcl_lnls">\
                                    <div class="fm-grp">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            全選\
                                        </label>\
                                    </div>\
                                    <div class = "fm-grp w-45p md-d-ib"> \
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            行程特色\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib txt-nowrap">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            每日行程景點介紹\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            自費活動參考\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            航班參考\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            簽證\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            安全守則\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            電話\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            電壓時差\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            Q & A\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            團體直客售價\
                                        </label>\
                                    </div>\
                                    <div class="fm-grp w-45p md-d-ib">\
                                        <label class="fm-chk">\
                                            <input type="checkbox">\
                                            <span class="indicator"></span>\
                                            業務連絡電話\
                                        </label>\
                                    </div>\
                                </div>\
                                <div class="fcl_lnls">\
                                    <div class="fm-grp">\
                                        <h4 class="title_change md-d-no d-b">其他事項</h4>\
                                        <label for="textarea">\
                                            <h4 class="d-no md-d-b">備註</h4>\
                                        </label>\
                                        <textarea class="fm-ctrl" id="textarea" style="resize:none" rows="3"></textarea>\
                                    </div>\
                                </div>\
                                <h4 class="title_change">業務連絡電話</h4>\
                                <ul class="info_list p-t-sm">\
                                    <li>凱尼斯旅行社有限公司</li>\
                                    <li>業務代表：許士仁</li>\
                                    <li>電話：02-22245654</li>\
                                    <li>傳真：02-22245654</li>\
                                </ul>\
                                <div class="btns clearfix wrapper-sm"> \
                                    <input class="cancel fz-md" type="button" value="取消"/>\
                                    <input class="confirm fz-md" type="button" value="送出"/>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
            '
      },
      zindex: null
    };

    Module.prototype.tmpl = function($) {
        var tmpl = function(str, data) {
            var f = !/[^\w\-\.:]/.test(str) ?
                tmpl.cache[str] = tmpl.cache[str] || tmpl(tmpl.load(str)) :
                new Function( // eslint-disable-line no-new-func
                    tmpl.arg + ',tmpl',
                    'var _e=tmpl.encode' + tmpl.helper + ",_s='" +
                    str.replace(tmpl.regexp, tmpl.func) + "';return _s;"
                )
            return data ? f(data, tmpl) : function(data) {
                return f(data, tmpl)
            }
        }
        tmpl.cache = {};
        tmpl.load = function(id) {
            return document.getElementById(id).innerHTML
        };
        tmpl.regexp = /([\s'\\])(?!(?:[^{]|\{(?!%))*%\})|(?:\{%(=|#)([\s\S]+?)%\})|(\{%)|(%\})/g
        tmpl.func = function(s, p1, p2, p3, p4, p5) {
            if (p1) { // whitespace, quote and backspace in HTML context
                return {
                    '\n': '\\n',
                    '\r': '\\r',
                    '\t': '\\t',
                    ' ': ' '
                }[p1] || '\\' + p1
            }
            if (p2) { // interpolation: {%=prop%}, or unescaped: {%#prop%}
                if (p2 === '=') {
                    return "'+_e(" + p3 + ")+'"
                }
                return "'+(" + p3 + "==null?'':" + p3 + ")+'"
            }
            if (p4) { // evaluation start tag: {%
                return "';"
            }
            if (p5) { // evaluation end tag: %}
                return "_s+='"
            }
        }
        tmpl.encReg = /[<>&"'\x00]/g // eslint-disable-line no-control-regex
        tmpl.encMap = {
            '<': '&lt;',
            '>': '&gt;',
            '&': '&amp;',
            '"': '&quot;',
            "'": '&#39;'
        }
        tmpl.encode = function(s) {
            return (s == null ? '' : '' + s).replace(
                tmpl.encReg,
                function(c) {
                    return tmpl.encMap[c] || ''
                }
            )
        }
        tmpl.arg = 'o';
        tmpl.helper = ",print=function(s,e){_s+=e?(s==null?'':s):_e(s);}" +
            ',include=function(s,d){_s+=tmpl(s,d);}';
        return tmpl;
    }(this);

    Module.prototype.topZIndex = function(selector) {
        return Math.max(
            0,
            Math.max.apply(
                null,
                $.map(
                    ((selector || "*") === "*") ? $.makeArray(document.getElementsByTagName("*")) : $(selector),
                    function(v) {
                        return parseFloat($(v).css("z-index")) || null;
                    }
                )
            )
        );
    };
    //初始化右側功能列模版
    Module.prototype.init = function() {
        $(this.elem).css({'height':this.opts.moduleHeight});
        var zindex = this.opts.zindex ? this.opts.zindex : this.topZIndex('*');
        var initElem = $(this.elem).html(this.tmpl(this.opts.template.ntbLnsdTemplate, {
            menus: this.opts.menus,
            goTopText:this.opts.goTopText,
            arrowIcon:this.opts.arrowIcon,
        }));
        if (this.opts.zindex !== 'none' && (this.opts.zindex !== undefined || this.opts.zindex !== null)) initElem.css('z-index', zindex);
    }
    Module.prototype.initRun = function() {
        this.opts.initRun();
    }
    //設定允許開啟內容，并返回
    Module.prototype.isAllowOpen = function(isallowopen) {
        if ($.type(isallowopen) != 'undefined') {
            this.opts.isAllowOpen = isallowopen;
        }
        return this.opts.isAllowOpen;
    }
    //開啟某個模塊
    Module.prototype.openSidebar = function(section, fn) {
        $.type(section) != 'undefined' && this.renderContent(section, fn);
        $(this.elem).animate({
            right: 0
        }, this.opts.time);
    }
    //關閉某個模塊
    Module.prototype.closeSidebar = function(collection) {
        var that = this;
        $(this.elem).animate({
            right: that.opts.sideHideDistance
        }, this.opts.time, function() {
            $(that.elem).find('.side-main-contain').remove();
        });
    }
    // 模塊數據緩存
    Module.prototype.inputContentData = function(section, data) {
        this.opts[section] = data;
    }
    //讀取緩存數據
    Module.prototype.outputContentData = function(section) {
        console.log(this.opts[section]);
        return this.opts[section];
    }
    //模塊渲染
    Module.prototype.renderContent = function(section, fn) {
        var template = this.opts.template;
        //1.取得this.opts[section]的数据
        var cdgpsms = '';
        var obj = null;
        //$(this.elem).find('.side-main-contain').remove();//寫到各個分支去，避免所傳模塊不存在
        switch (section) {
            case 'favorite':
                $(this.elem).find('.side-main').html('');
                if (typeof this.opts === 'object' && this.opts.hasOwnProperty(section) && this.opts[section] !== null) {
                    obj = this.opts[section].items;
                }
                if (obj && obj.length > 0) {
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.favoriteTemplate, {
                        banner: this.opts.banner
                    }));
                    for (var i = 0; i < obj.length; i++) {
                        cdgpsms += this.tmpl(template.cdGpsm, obj[i])
                    }
                    $(this.elem).find('.contain-list').append(cdgpsms);
                    var lists = this.tmpl(template.lis, this.opts[section]);
                    $(this.elem).find('.favorite-tips').append(lists);
                } else {
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.nodata, {
                        content: "您尚未開始收藏產品"
                    }));
                }

                break;
            case 'compare':
                $(this.elem).find('.side-main').html('');
                obj = this.opts[section];
                if (obj !== null && obj.items && obj.items.length > 1) {
                    console.log("obj.items.length > 1")
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.pannel, obj, {
                        banner: this.opts.banner,
                        items: obj.items
                    }));
                } else if (obj !== null && obj.items && obj.items.length == 1) {
                    console.log("obj.items.length ==1")
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.comparisonTemplate, {
                        banner: this.opts.banner,
                        items: obj.items
                    }));
                    for (var i = 0; i < obj.items.length; i++) {
                        cdgpsms += this.tmpl(template.cdGpsm, obj.items[i])
                    }
                    $(this.elem).find('.contain-list').append(cdgpsms);
                } else {
                    console.log("!obj.items.length > 1 && !obj.items.length ==1")
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.nodata, {
                        content: "您尚未開始比較產品"
                    }));
                }
                break;
            case 'compareLionBobby':
                $(this.elem).find('.side-main').html('');
                obj = this.opts[section];
                if (obj !== null && obj.items && obj.items.length > 1) {
                    console.log("obj.items.length > 1")
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.pannelLionBobby, obj, {
                        banner: this.opts.banner,
                        items: obj.items
                    }));
                } else if (obj !== null && obj.items && obj.items.length == 1) {
                    console.log("obj.items.length ==1")
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.comparisonTemplate, {
                        banner: this.opts.banner,
                        items: obj.items
                    }));
                    for (var i = 0; i < obj.items.length; i++) {
                        cdgpsms += this.tmpl(template.cdGpsm, obj.items[i])
                    }
                    $(this.elem).find('.contain-list').append(cdgpsms);
                } else {
                    console.log("!obj.items.length > 1 && !obj.items.length ==1")
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.nodata, {
                        content: "您尚未開始比較產品"
                    }));
                }
                break;
            case 'historyOld':
                $(this.elem).find('.side-main').html('');
                obj = this.opts[section];
                if (obj && obj.items.length > 0) {
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.historyTemplate));
                    for (var i = 0; i < obj.items.length; i++) {
                        cdgpsms += this.tmpl(template.cdGpsm, obj.items[i])
                    }
                    $(this.elem).find('.contain-list').append(cdgpsms);
                }else {
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.nodata, {
                        content: "目前沒有瀏覽過的產品"
                    }));
                }

                break;
            case 'history':
                $(this.elem).find('.side-main').html('');
                obj = this.opts[section];
                if (obj !== null && obj.items && obj.items.length > 1) {
                    console.log("obj.items.length > 1")
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.historyPanel, obj, {
                        banner: this.opts.banner,
                        items: obj.items
                    }));
                    if (typeof this.opts.historyCardTemplateMode === 'string' && this.opts.historyCardTemplateMode === 'card') {
                        for (var i = 0; i < obj.items.length; i++) {
                            cdgpsms += this.tmpl(template.cdGpsm, obj.items[i])
                        }
                        $(this.elem).find('.contain-list').append(cdgpsms);
                    }
                } else if (obj !== null && obj.items && obj.items.length == 1) {
                    console.log("obj.items.length ==1")
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.historyPanel, {
                        banner: this.opts.banner,
                        items: obj.items
                    }));
                    if (typeof this.opts.historyCardTemplateMode === 'string' && this.opts.historyCardTemplateMode === 'card') {
                        for (var i = 0; i < obj.items.length; i++) {
                            cdgpsms += this.tmpl(template.cdGpsm, obj.items[i])
                        }
                        $(this.elem).find('.contain-list').append(cdgpsms);
                    }
                } else {
                    $(this.elem).find('.side-main').prepend(this.tmpl(template.nodata, {
                        content: "目前沒有瀏覽過的產品"
                    }));
                }

                break;
            case 'shares':
                $(this.elem).find('.side-main').html('');
                $(this.elem).find('.side-main').prepend(this.tmpl(template.shares, {
                    banner: this.opts.banner
                }));
                break;
            case 'shares_forward':
                $(this.elem).find('.side-main').html('');
                $(this.elem).find('.side-main').prepend(this.tmpl(template.shares_forward, {
                    banner: this.opts.banner
                }));
                break;
            default:
                break;
        }
        $(this.elem).find('.nav-btn.arrow').removeClass('d-no');
        $(this.elem).find('.btn-a').removeClass('expanded');
        $(this.elem).find('.' + section).addClass('expanded');
        $(this.elem).addClass('expanded-all')
        //2.調用回調函數
        $.type(fn) == 'function' && fn();
    }
    //清除section塊
    Module.prototype.cleanupContent = function(section, fn) {
        this.opts[section] = null;
        this.elem.find('.side-main-contain').remove();
        $.type(fn) == 'function' && fn();
    }
    //添加item到對應模塊
    Module.prototype.addItem = function(section, o, fn) {
        this.opts[section] = this.opts[section] || {
            items: []
        };
        var data = this.opts[section].items;
        var arr, index;
        for (var i = 0; i < data.length; i++) {
            if (data[i].type == o.type) {
                arr = data[i].data;
                index = i;
                arr.unshift(o)
                break;
            }
        }
        if ($.type(index) == 'undefined') {
            var typeName = this.opts.types[o.type]
            data.push({
                type: o.type,
                typeName: typeName,
                data: [o]
            })
        }
        $.type(fn) == 'function' && fn();
    }
    //刪除某個模塊的某條數據
    Module.prototype.delItem = function(section, o, fn) {
        var data = this.opts[section].items;
        var arr;
        var index = null;
        var indexes;
        for (var i = 0; i < data.length; i++) {
            if (data[i].type == o.type) {
                arr = data[i].data;
                break;
            }
        }
        for (var j = 0; j < arr.length; j++) {
            if (arr[j].key == o.key) {
                arr.splice(j, 1);
                break;
            }
        }
        indexes = data.map(function(obj, index) {
            if (obj.data.length === 0) {
                return index;
            }
        }).filter(function(value) {
            return typeof value !== 'undefined';
        });
        for (var z = 0; z < indexes.length; z++) {
            data.splice(indexes[z], 1);
        }
        if (data.length === 0) {
            this.renderContent(section);
        }
        $.type(fn) == 'function' && fn();
    }
    //按鈕事件
    Module.prototype.events = function(elem, closeFlag, fn) {
        var that = this;
        if ($(elem).hasClass('expanded')) {
            $(elem).removeClass('expanded');
            $(this.elem).removeClass('expanded-all')
            this.closeSidebar();
            $(this.elem).find('.nav-btn.arrow').addClass('d-no');
            return;
        }
        if(closeFlag){
            $(this.elem).addClass('expanded-all');
            $(this.elem).find('.nav-btn.arrow').removeClass('d-no');
        }
        $(this.elem).find('.btn-a').removeClass('expanded');
        $(elem).addClass('expanded');
        $.type(fn) == 'function' && fn();
    }
    //按鈕綁定事件
    Module.prototype.bindClik = function() {
        var that = this,
            clicks = this.opts.clickItemEvents;
        // 註冊body click事件可以關閉
        $('body').on('click', function() {
            if ($('.ntb_lnsd').hasClass('expanded-all')) {
                $('.ntb_lnsd').ntb_lnsd('events', $('.btn-a.expanded').get(0));
            }
        });
        //綁定收藏按鈕事件 expanded-all設置sidebar是否全部顯示，expanded設置是否顯示按鈕提示
        $(this.elem).on('click', function(e) {
            //e.preventDefault();
            e.stopPropagation();
        })
        $(this.elem).on('click', 'a.favorite', function(ev) {
            that.events(this, true, clicks.favorite);
        });
        //綁定比較按鈕事件
        $(this.elem).on('click', 'a.compare', function(ev) {
            that.events(this, true, clicks.comparison);
        });
        //綁定PDF下載按鈕
        $(this.elem).on('click', 'a.pdfDownload', function(ev) {
            that.events(this, false, clicks.downloadPDF);
        });
        //綁定列印按鈕
        $(this.elem).on('click', 'a.printf', function(ev) {
            that.events(this, false, clicks.previewPrint);
        });
        //綁定看過按鈕
        $(this.elem).on('click', `a.history`, function(ev) {
            that.events(this, true, clicks.history);
        });
        // 綁定看過按鈕(舊版)
        $(this.elem).on('click', `a.historyOld`, function(ev) {
            that.events(this, true, clicks.historyOld);
        });
        //綁定分享
        $(this.elem).on('click', 'a.shares', function(ev) {
            that.events(this, true, clicks.share);
        });
        //綁定分享
        $(this.elem).on("click", "a.shares_forward", function(ev) {
            that.events(this, true, clicks.shares_forward);
        });
        //綁定分享
        $(this.elem).on('click', 'a.credit', function(ev) {
            that.events(this, true, clicks.credit);
        });
        //goTop
        $(this.elem).on('click', 'a.toTop', function(ev) {
            clicks.goTop();
        });
        //隐藏面板
        $(this.elem).on('click', '.nav-btn.arrow', function(ev) {
            that.closeSidebar();
            $(that.elem).find('.btn-a').removeClass('expanded');
            $(that.elem).removeClass('expanded-all')
            $(this).addClass('d-no');
        });
        //綁定複製
         $(this.elem).on("click", "a.copy", function(ev) {
            that.events(this, true, clicks.copy);
        });
        //绑定比较面板
        // $(this.elem).on('click','a.pannel-btn',function(ev){
        //     var type=$(this).attr('type');
        //     var data;
        //     for(var i=0;i<that.opts.compare.items.length;i++)
        //     {
        //         if(that.opts.compare.items[i].type==type)
        //         {
        //             data=that.opts.compare.items[i].data;
        //             break;
        //         }
        //     }
        //     $(that.elem).find('.side-main-contain').remove();
        //     $(that.elem).find('.side-main').prepend(that.tmpl(that.opts.template.comparisonTemplate, {banner: that.opts.banner}));
        //     var cdgpsms=that.tmpl(that.opts.template.cdGpsm,{data:data});
        //     $(that.elem).find('.contain-list').append(cdgpsms);
        //     //添加刪除事件
        //     that.opts.pannelCB();
        // });
        //綁定轉寄給按鈕
        $(this.elem).on('click', 'a.share-o', function(ev) {
            if ($(this).hasClass('open')) {
                $(that.elem).find('.share-form').slideUp({
                    duration: 200
                });
            } else {
                $(that.elem).find('.share-form').slideDown({
                    duration: 200
                });
            }
            $(this).toggleClass('open');
        });
    }
    //添加鼠標移動到sidebar上的hover事件
    Module.prototype.bindHover = function() {
        var that = this;
        $(this.elem).find('.side-nav').hover(function() {
            $(that.elem).addClass('show-all')
        }, function() {
            $(that.elem).removeClass('show-all')
        });
    }
    Module.prototype.OtoStr = function(obj) {
        var str = '';
        for (var key in obj) {
            str += key + '=' + obj[key] + ' ';
        }
        return str;
    }
    //添加項目效果
    Module.prototype.addItemEffect = function(section,fn) {
        var btn = $('.ntb_lnsd .nav-btn').children('.'+section);
        btn.addClass('checking checked');
        setTimeout(function(){
            btn.removeClass('checking');
            if (section==='favorite') {
                btn.children('i').removeClass('toollike').addClass('toollikef');
            }
        },2000);
        $.type(fn) == 'function' && fn();
    }
    //移除項目效果
    Module.prototype.removeItemEffect = function(section,fn) {
        var btn = $('.ntb_lnsd .nav-btn').children('.'+section);
        btn.removeClass('checking checked');
        if (section==='favorite') {
            btn.children('i').removeClass('toollikef').addClass('toollike');
        }
        $.type(fn) == 'function' && fn();
    }
    $.fn[ModuleName] = function(options, options2, options3, options4) {
        return this.each(function() {
            var $this = $(this);
            var module = $this.data(ModuleName);
            var opts = null;
            if (!!module) {
                if ($.type(options) === 'string' && $.type(options2) === 'undefined' && $.type(options3) === 'undefined' && $.type(options4) === 'undefined') {
                    module[options]();
                } else if ($.type(options) === 'string' && $.type(options2) != 'undefined' && $.type(options3) === 'undefined' && $.type(options4) === 'undefined') {
                    module[options](options2);
                } else if ($.type(options) === 'string' && $.type(options2) != 'undefined' && $.type(options3) != 'undefined' && $.type(options4) === 'undefined') {
                    module[options](options2, options3);
                } else if ($.type(options) === 'string' && $.type(options2) != 'undefined' && $.type(options3) != 'undefined' && $.type(options4) != 'undefined') {
                    module[options](options2, options3, options4);
                } else {
                    console.log('unsupported options!');
                    throw 'unsupported options!';
                }
            } else {
                opts = $.extend(true, {}, Module.DEFAULT, ($.type(options) === 'object' && options), ($.type(options2) === 'object' && options2));
                module = new Module(this, opts);
                module.init();
                module.bindClik();
                module.bindHover();
                $this.data(ModuleName, module);
            }
        })
    }
})(jQuery);